// extracted by mini-css-extract-plugin
export default {"control":"HVPagination_module-T3FVQVLY_control__qhEZB","dots":"HVPagination_module-T3FVQVLY_dots__HtJUc"};